<template>
  <ToastModal
    ref="modal"
    show-mobile-footer
    modal-id="HasAddedNewMembershipModal"
  >
    <div class="flex justify-center pt-7">
      <OSvg svg="checkmark-icon" />
    </div>
    <p class="o-heading-2 text-center my-5" v-text="title ? title :$t('ExploreMemberships.Modals.HasAddedNewMembership.Title')" />
    <p class="o-body text-center my-5" v-text="description ? description : $t('ExploreMemberships.Modals.HasAddedNewMembership.Description')" />
    <div class="mb-5 mt-10">
      <p class="o-body font-bold mb-1" v-text="name" />
      <div class="py-5 px-4 bg-neutral-50">
        <div class="flex justify-between items-center">
          <p class="o-heading-4" v-text="$t(`MemberShipTypes.${membershipTypeReference}.Name`)" />
          <div v-if="originalPrice || price" class="flex flex-col items-end">
            <p v-if="originalPrice" class="o-caption text-neutral-800 mb-1 line-through" v-text="`${$t('ExploreMemberships.PerMonth', { price: originalPrice })}`" />
            <p v-if="price" class="o-caption text-neutral-800 mb-1" v-text="`${$t('ExploreMemberships.PerMonth', { price })}`" />
          </div>
        </div>
        <p
          v-for="(size, i) in sizes"
          :key="`${size}-${i}`"
          class="o-body"
          v-text="`${$t('Account.CancelMembershipForm.Step.pauseFlow.Modal.Size')} ${size.toUpperCase()}`"
        />
      </div>
    </div>
    <div class="mb-5">
      <p class="block o-body" v-text="$t('Account.CancelMembershipForm.Step.pauseFlow.Modal.NextPayment')" />
      <p class="font-bold o-body" v-text="formattedNextPaymentDate" />
    </div>
    <div class="mb-5">
      <p class="block o-body" v-text="$t('ExploreMemberships.Modals.HasAddedNewMembership.NextDelivery')" />
      <p class="font-bold o-body" v-text="formattedNextDeliveryDate" />
    </div>
    <template v-slot:footer>
      <ToastModalFooter class="w-full" color="black" variant="outline" @click="onModalClose" />
    </template>
  </ToastModal>
</template>

<script>
import ToastModal from '@/components/ToastModal'
import ToastModalFooter from '@/components/ToastModal/ToastModalFooter'
import OSvg from '@/components/OSvg'

export default {
  name: 'HasAddedNewMembershipModal',
  components: {
    ToastModal,
    ToastModalFooter,
    OSvg
  },
  props: {
    name: {
      type: String,
      default: ''
    },
    membershipTypeReference: {
      type: String,
      default: ''
    },
    price: {
      type: String,
      default: ''
    },
    originalPrice: {
      type: String,
      default: ''
    },
    sizes: {
      type: Array,
      default: () => ([])
    },
    nextPaymentDate: {
      type: String,
      default: ''
    },
    nextDeliveryDate: {
      type: String,
      default: ''
    },
    title: {
      type: String,
      default: ''
    },
    description: {
      type: String,
      default: ''
    }
  },
  computed: {
    formattedNextPaymentDate () {
      const paymentDate = this.$moment.utc(this.nextPaymentDate)

      return `${paymentDate.date()} ${this.$t(`Months[${paymentDate.month()}]`)} ${paymentDate.format('YYYY')}`
    },
    formattedNextDeliveryDate () {
      const deliveryDate = this.$moment.utc(this.nextDeliveryDate)

      return `${deliveryDate.date()} - ${deliveryDate.date() + 6} ${this.$t(`Months[${deliveryDate.month()}]`)} ${deliveryDate.format('YYYY')}`
    }
  },
  methods: {
    toggleActivation () {
      this.$refs.modal.toggleActivation()
    },
    onModalClose () {
      this.$refs.modal.onModalClose()
    }
  }
}
</script>

<style lang="postcss" scoped>

</style>
